import { render, staticRenderFns } from "./ShipperRecap.vue?vue&type=template&id=035e73dc"
import script from "./ShipperRecap.vue?vue&type=script&lang=js"
export * from "./ShipperRecap.vue?vue&type=script&lang=js"
import style0 from "./ShipperRecap.vue?vue&type=style&index=0&id=035e73dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports